export const CHARGINGPOINT_STATUS = {
  GEPLANNED: "definitive",
  VOORGESTELD: "suggestion",
}

export const VALIDATION_VOTE = {
  APPROVED: 'Goedgekeurd',
  REJECTED: 'Afgekeurd',
}

export const ACTION_SIDEBAR_TAB = {
  INFO: 'info',
  MONITORING: 'monitoring',
  OPMERKINGEN: 'opmerkingen',
}